import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Popup from "./BasePopup";
import Button from "../CommonFields/Button";
import moment from "moment";
import { tournamentMatchByRoundId } from "../../api/tournament.api";
import { userWalletLimit } from "../../api/auth.api";
import { toastError, toastSuccess } from '../../Utilities/toast.js'

const TournamentRoundPopup = ({ isOpen, title, onClose, tournaments, rounds, firstRoundId, setFirstRoundId, setSelectedMatchDate, setisTournamentRound, setisTournamentJoiningPopup, setWalletUsageData, setCoinStore }) => {
  const [currentRound, setCurrentRound] = useState(0);
  const [contestList, setContestList] = useState([]);
  const [finaleData, setFinaleData] = useState(null);
  const [firstRoundMatchId, setFirstRoundMatchId] = useState("");
  const [roundsNext, setRounds] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [contest, setContest] = useState("");
  const [uniqueIgn, setUniqueIgn] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    CheckRounds()
  }, [rounds])

  const CheckRounds = async () => {
    var today = new Date();
    let result = rounds?.item?.filter((item) => {
      var itDate = moment(item?.date).format("y-MM-DD");
      var itTime = moment(item?.time).format("HH:mm:ss");
      var itmeD = moment(itDate + " " + itTime);
      if (today < itmeD) return true
    })

    const uniqueItems = [];
    const seenTimes = new Set();
    result?.forEach(obj => {
      var itDate = moment(obj?.date).format("y-MM-DD");
      var itTime = moment(obj?.time).format("HH:mm");
      var currentTime = itDate + " " + itTime
      if (!seenTimes.has(currentTime)) {
        uniqueItems.push(obj);
        seenTimes.add(currentTime); // Mark this time as seen
      }
    });

    setContestList(uniqueItems)
    setFinaleData(rounds?.lastRound);
    setFirstRoundMatchId("");
    var tempRound = rounds?.item?.[rounds?.item.length - 1];

    var today = new Date();
    var cdate = moment(tempRound?.date).format("y-MM-DD");
    var ctime = moment(tempRound?.time).format("HH:mm:ss");
    var contestDateTime = moment(cdate + " " + ctime);

    var isShowTournament = true;
    if (result?.length == 0 || today > new Date(contestDateTime)) {
      isShowTournament = false;
    }
    isShowTournament = true;

    if (isShowTournament) {
      let payloadWalletLimit = {
        currencyCode: tournaments?.currency?.[0]?.inCurrency?._id,
      };

      let responseUserWalletLimit = await userWalletLimit(payloadWalletLimit);
      if (responseUserWalletLimit?.success && responseUserWalletLimit?.data) {
        setCoinStore(
          responseUserWalletLimit?.data?.winningAmount >= tournaments?.entryFee
            ? false
            : true
        );
        setWalletUsageData(responseUserWalletLimit?.data);
      }
      else {
        setCoinStore(true);
      }
    }
    else {
      toastError(t('errors.error_oops_this_tournament_has_already_started'));
    }
  }
  const handleRadioChange = async (item) => {
    let body = {
      code: item?.code
    }

    let response = await tournamentMatchByRoundId(tournaments?._id, body);
    if (response?.success) {
      setFirstRoundMatchId(item._id);
      setSelectedDate(moment(item?.date).format("D MMMM YYYY") + ", " + moment(item?.time).format("hh:mm A"));
      setSelectedMatchDate(moment(item?.date).format("D MMM YYYY") + ", " + moment(item?.time).format("hh:mm A"));
      let temp = [];
      temp = response?.data?.matches?.reduce((item, val1) => {
        let data = {
          round: val1.name,
          date: val1?.matches?.[0]?.date,
          time: val1?.matches?.[0]?.time

        }
        item.push(data)
        return item
      }, [])
      setRounds(temp);
      setContest(item._id);
    }
  };
  const handlePreviousRound = () => {
    if (currentRound > 0) {
      setCurrentRound(currentRound - 1);
    }
  };
  const handleNextRound = () => {
    if (currentRound < (roundsNext?.length - 1)) {
      setCurrentRound(currentRound + 1);
    }
  };
  const onNext = () => {
    if (firstRoundMatchId !== "") {
      setFirstRoundId(firstRoundMatchId)
      setisTournamentRound(false)
      setisTournamentJoiningPopup(true)
    } else {
      toastError(t('errors.error_please_select_match'));
      // setisTournamentRound(false);
      setisTournamentJoiningPopup(false);
    }
  };

  return (
    <Popup isOpen={isOpen} title={title} onClose={onClose} BiggerTitle={true}>
      <div className="tournament-round-popup">
        <div className="tournament-round-inner-wrapper">
          <div className="tournament-round-header-details">
            <div className="col-12 tournament-round-popup-title">{tournaments?.gameAry?.name} -{" "} {tournaments?.gameTypeAry?.name}</div>
            {/* <div className="col-12 tournament-round-popup-date">
              {moment(tournaments?.startDate).format("Do MMMM Y")} {t('tournament_list.to')} {moment(tournaments?.endDate).format("Do MMMM Y")}
            </div> */}
            <div className="col-12 tournament-round-popup-date">
  {moment(tournaments?.startDate).format("D MMMM YYYY")} {t('tournament_list.to')} {moment(tournaments?.endDate).format("D MMMM YYYY")}
</div>

            <div className="col-12 tournament-round-select-timings">
              {t('tournament_list.select_first_round_timing', { round: `1st` })}
            </div>
          </div>
          <div className="tournament-round-basic-details">
            <div className="tournament-selectround-time">
              {contestList.map((round, index) => (
                <label key={index} className="custom-radio">
                  <input
                    type="radio"
                    name="selectRound"
                    // checked={selectedRecord === index} // Check if this record is selected
                    onChange={() => handleRadioChange(round)} // Set selected record on change
                  />
                  <span className="radio-btn"></span>
                  <span>{moment(round?.date).format("D MMMM YYYY")}, {moment(round?.time).format("hh:mm A")}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Show pagination if a record is selected or if the current round is greater than 1 */}
          {firstRoundMatchId === "" ? (
            <div className="tournament-round-slotsinfo">
              <div className="tournament-selecttime-info">
                {t('tournament_list.select_match_to_check_next_round_timings')}
              </div>
            </div>
          ) : (
            <div className="tournament-pagination-wrapper">
              <div className="pagination-container">
                <button
                  className="prev-btn"
                  onClick={handlePreviousRound}
                  disabled={currentRound === 0}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="24"
                      height="24"
                      rx="2"
                      transform="matrix(-1 0 0 1 24 0)"
                      fill="#82838E"
                    />
                    <g opacity="0.5">
                      <path
                        d="M13.6001 16L9.6001 12L13.6001 8"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </svg>
                </button>

                <span className="round-details">{roundsNext?.[currentRound]?.round}</span>

                <button
                  className="next-btn"
                  onClick={handleNextRound}
                  disabled={currentRound === (roundsNext?.length - 1)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2" fill="#82838E" />
                    <path
                      d="M10.3999 16L14.3999 12L10.3999 8"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div className="round-time">{moment(roundsNext?.[currentRound]?.date).format("D MMMM YYYY")}, {moment(roundsNext?.[currentRound]?.time).format("hh:mm A")}</div>
            </div>
          )}

          <div className="tournament-round-slotsinfo">
            <div className="tournament-selecttimefinal-info">
              {t('tournament_list.finale_will_be_scheduled_on')} {moment(finaleData?.date).format("D MMMM YYYY")}, {moment(finaleData?.time).format("hh:mm A")}
            </div>
          </div>
          <div className='my-4 mb-2'>
          <Button text={t('tournament_list.next')} onClick={() => onNext()} disabled={firstRoundMatchId !== "" ? false : true} />
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default TournamentRoundPopup;
